import messages from './member.json' with { type: 'json' };

export const memberEn: Readonly<typeof messages> = messages;
